module.exports = __webpack_public_path__ + "img/horizontal_4_7_7042.51ff844f.png";